export default __webpack_public_path__ + "static/media/vg-logo.e5a65949.svg";